"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeProject = void 0;
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const Project_1 = require("../entity/Project");
const creationSet_1 = require("./creationSet");
const creativeFormat_1 = require("./creativeFormat");
const dynamicSchemaDefinition_1 = require("./dynamicSchemaDefinition");
const dynamicSchemaValue_1 = require("./dynamicSchemaValue");
const organization_1 = require("./organization");
const projectType_1 = require("./projectType");
const user_1 = require("./user");
const createSomeProject = ({ id = '2', versionId = '5', organization = organization_1.createSomeOrganization(), originId = id, parentId = null, title = 'Lorem Ipsum', state = Project_1.ProjectState.submitted, demo = false, createdBy = user_1.createSomeDirectorUser(), projectType = projectType_1.createSomeProjectType(), creationSets = immutable_1.List.of(creationSet_1.createSomeCreationSet({
    creativeFormats: immutable_1.List.of(creativeFormat_1.createSomeCreativeFormat({ id: '50' }), creativeFormat_1.createSomeCreativeFormat({ id: '51' }), creativeFormat_1.createSomeCreativeFormat({ id: '52' })),
}), creationSet_1.createSomeCreationSet({
    creativeFormats: immutable_1.List.of(creativeFormat_1.createSomeCreativeFormat({ id: '53' }), creativeFormat_1.createSomeCreativeFormat({ id: '54' }), creativeFormat_1.createSomeCreativeFormat({ id: '55' })),
})), creativeBriefDefinition = dynamicSchemaDefinition_1.createSomeDynamicSchemaDefinition(), creativeBriefValue = dynamicSchemaValue_1.createSomeDynamicSchemaValue(), createdAt = luxon_1.DateTime.fromMillis(1518162885346, { zone: 'utc' }), updatedAt = luxon_1.DateTime.fromMillis(1518162888888, { zone: 'utc' }), submittedAt = null, canCreativeVisibilityOnProfile = true, matchingFormat = 'auto', asset = null, assetCategoryValue = dynamicSchemaValue_1.createSomeDynamicSchemaValue(), assetCategoryDefinition = dynamicSchemaDefinition_1.createSomeDynamicSchemaDefinition(), } = {}) => new Project_1.default({
    id,
    versionId,
    organization,
    originId,
    parentId,
    title,
    state,
    demo,
    createdBy,
    projectType,
    creationSets,
    creativeBriefDefinition,
    creativeBriefValue,
    createdAt,
    updatedAt,
    submittedAt,
    canCreativeVisibilityOnProfile,
    matchingFormat,
    asset,
    assetCategoryValue,
    assetCategoryDefinition,
});
exports.createSomeProject = createSomeProject;
